import axios from 'axios';
import axiosHelper from 'utils/axiosHelper';


// Requête pour obtenir les utilisateurs d'une agence, profil MAG, hors "COMPTOIR ..."
// 
export const fetchUtilisateurAgence = async ({ codeAgence }) => {

    const { data } = await axios.get(`api/utilisateurs/agence/${codeAgence}`);

    return data;
};


// Requête pour obtenir le taux de réclamation société
// 
export const fetchTauxReclamationSociete = async () => {

    const { data } = await axios.get(`api/reclamations/tauxSociete`);

    return data;
};


// Requête pour obtenir la dernière action d'un type
// 
export const fetchDerniereAction = async ({ reclamationId, typeActionCode }) => {

    let params = {
        typeActionCode: typeActionCode
    };

    const { data } = await axios.get(`api/reclamations/${reclamationId}/actions/derniere`, { params: params, paramsSerializer: axiosHelper.transformRequestOptions });

    return data;
};


// Requête pour obtenir les frais de retour
// 
export const fetchAdministrationFraisRetour = async () => {

    const { data } = await axios.get(`api/frais-retour/administration`);

    return data;
};


// Requête pour obtenir les catégories SAV
// 
export const fetchSAVCategories = async () => {

    const { data } = await axios.get(`api/sav-categories`);

    return data;
};


// Requête pour obtenir les catégories SAV pour l'administration
// 
export const fetchAdministrationSAVCategories = async () => {

    const { data } = await axios.get(`api/sav-categories/administration`);

    return data;
};

// Requête pour obtenir les liaisons SAV fournisseur / client
// 
export const fetchSAVFournisseursClients = async () => {

    const { data } = await axios.get(`api/sav-fournisseurs/clients`);

    return data;
};


// Requête pour obtenir les liaisons SAV fournisseur / dépôt
// 
export const fetchSAVFournisseursDepots = async () => {

    const { data } = await axios.get(`api/sav-fournisseurs/depots`);

    return data;
};

// Requête pour obtenir les fournisseurs configurés pour faire du SAV By Foussier
// 
export const fetchSAVByFoussierFournisseurs = async () => {

    const { data } = await axios.get(`api/sav-fournisseurs/sav-by-foussier`);

    return data;
};


// Requête pour obtenir les liaisons dépots gestion
// 
export const fetchSAVDepotsGestion = async () => {

    const { data } = await axios.get(`api/depots-gestion/sav`);

    return data;
};



// Requête pour obtenir les marques pour l'administration
// 
export const fetchAdministrationMarques = async () => {

    const { data } = await axios.get(`api/marques/administration`);

    return data;
};

// Requête pour obtenir les marques éventuellement filtrées pour un fournisseur
// 
export const fetchMarques = async ({ fournisseurId }) => {

    let params = { fournisseurId: fournisseurId };

    const { data } = await axios.get(`api/marques/`, { params: params, paramsSerializer: axiosHelper.transformRequestOptions });

    return data;
};

// Requête pour obtenir un paramètre
// 
export const fetchParametre = async ({ parametre }) => {

    const { data } = await axios.get(`api/parametres/${parametre}`);

    return data;
};

// Requête pour obtenir les montants mini exclus au retour
// 
export const fetchMontantMiniRetourExclus = async () => {

    const { data } = await axios.get(`api/montantMiniRetourExclus/administration`);

    return data;
};


// Requête pour obtenir des clients pour l'administration
// 
export const fetchClientsAdministration = async (param) => {

    const { data } = await axios.post(`/api/clients/administration`, param);

    return data;
};


// Requête pour obtenir les infos générales d'un client
// 
export const fetchClientInfosGenerales = async (idClient, numeroPiece) => {

    let params = { numeroPiece: numeroPiece };

    const { data } = await axios.get(`api/clients/${idClient}/infos-generales`, { params: params, paramsSerializer: axiosHelper.transformRequestOptions });

    return data;
};

// Requête pour obtenir les infos d'un utilisateur
// 
export const fetchAdministrationUtilisateur = async (id) => {

    const { data } = await axios.get(`api/utilisateurs/administration/${id}`);

    return data;
};


// Requête pour obtenir des dépots gestion pour l'administration
// 
export const fetchDepotsGestionAdministration = async (param) => {

    const { data } = await axios.post(`/api/depots-gestion/administration`, param);

    return data;
};


// requête pour obtenir les contacts d'un client pour les notification des formulaires
//
export const fetchClientContactsNotification = async (clientId) => {

    const { data } = await axios.get(`api/clients/${clientId}/contacts-notification`);

    return data;

};

// requête pour obtenir les éléments paramétrés de l'arborescence
//
export const fetchArborescenceElementsParametres = async () => {

    const { data } = await axios.get(`api/arborescence-gestion/elements-parametres`);

    return data;

};

// requête pour obtenir tous les éléments de l'arborescence
//
export const fetchElementsArborescence = async () => {

    const { data } = await axios.get(`api/arborescence-gestion`);

    return data;

};

// requête pour obtenir tous les éléments de l'arborescence de façon brute
// 
export const fetchArborescenceGestionBrute = async () => {

    const { data } = await axios.get(`api/arborescence-gestion/brute`);

    return data;
};


// Requête pour obtenir des articles gestion pour l'administration
// 
export const fetchArticlesGestionAdministration = async (param) => {

    const { data } = await axios.post(`/api/articles-gestion/administration`, param);

    return data;
};
